import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchAttentionPoints, type AttentionPoint } from '@/lib/api';

interface NotificationState {
  points: AttentionPoint[];
  loading: boolean;
  refresh: () => void;
}

const NotificationContext = createContext<NotificationState>({
  points: [],
  loading: false,
  refresh: () => {},
});

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [points, setPoints] = useState<AttentionPoint[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    fetchAttentionPoints()
      .then(setPoints)
      .catch(() => setPoints([])) // stil falen: de bel mag de app nooit breken
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <NotificationContext.Provider value={{ points, loading, refresh }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}
